import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const setItemFormData = (state, { payload }) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload
    },
  };
};

const clearItemFormData  = (state) =>{
  return {
    ...state,
    data:{}
  }
}

const initialState = {};

export default createReducer(initialState, {
  [TYPES.SET_ITEM_FORM_DATA]: setItemFormData,
  [TYPES.CLEAR_ITEM_FORM_DATA]: clearItemFormData
});
